import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/uslugi', label: 'Usługi' },
  { to: '/realizacje', label: 'Realizacje' },
  { to: '/proces', label: 'Proces' },
  { to: '/pakiety', label: 'Pakiety' },
  { to: '/blog', label: 'Blog' },
  { to: '/o-nas', label: 'O nas' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <>
      <nav
        className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
        style={{
          background: scrolled ? 'rgba(10,10,10,0.90)' : 'transparent',
          backdropFilter: scrolled ? 'blur(20px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : '1px solid transparent',
        }}
      >
        <div className="max-w-[1400px] mx-auto px-6 py-2 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center group cursor-pointer">
            <img
              src="https://storage.readdy-site.link/project_files/c74744eb-3995-40db-8fce-b59523b1b313/898a52d7-18aa-43c2-be1f-5134a7f25dee_ChatGPT-Image-24-mar-2026-07_22_57.png?v=a14bd4da0532dd836168e272800ed8fb"
              alt="Orsonet - Wdrożenia AI"
              className="h-16 w-auto object-contain transition-all duration-300 group-hover:opacity-90 group-hover:scale-[1.03]"
              style={{ maxWidth: '210px' }}
            />
          </Link>

          {/* Desktop links */}
          <div className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap"
                style={{
                  color: location.pathname.startsWith(link.to) ? '#00d4ff' : 'rgba(255,255,255,0.65)',
                  background: location.pathname.startsWith(link.to) ? 'rgba(0,212,255,0.08)' : 'transparent',
                }}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:+48600601093"
              className="px-4 py-2.5 rounded-xl text-sm font-medium text-white/60 hover:text-white flex items-center gap-2 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-[#00ff88]" />
              600 601 093
            </a>
            <Link
              to="/kontakt"
              className="px-5 py-2.5 rounded-xl text-sm font-bold text-black whitespace-nowrap cursor-pointer transition-all hover:scale-105 shadow-[0_0_20px_rgba(0,212,255,0.3)]"
              style={{ background: 'linear-gradient(135deg, #00d4ff, #00b8e6)' }}
            >
              Bezpłatna konsultacja
            </Link>
          </div>

          {/* Mobile burger */}
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      <div
        className="fixed inset-0 z-40 lg:hidden transition-all duration-300"
        style={{
          opacity: menuOpen ? 1 : 0,
          pointerEvents: menuOpen ? 'auto' : 'none',
        }}
      >
        <div className="absolute inset-0 bg-black/95 backdrop-blur-xl" onClick={() => setMenuOpen(false)} />
        <div
          className="absolute top-20 left-4 right-4 rounded-2xl border border-white/10 bg-[#0f0f0f] p-6 transition-all duration-300"
          style={{
            transform: menuOpen ? 'translateY(0)' : 'translateY(-20px)',
          }}
        >
          {/* Mobile logo */}
          <div className="flex justify-center mb-6 pb-5 border-b border-white/8">
            <img
              src="https://storage.readdy-site.link/project_files/c74744eb-3995-40db-8fce-b59523b1b313/898a52d7-18aa-43c2-be1f-5134a7f25dee_ChatGPT-Image-24-mar-2026-07_22_57.png?v=a14bd4da0532dd836168e272800ed8fb"
              alt="Orsonet"
              className="h-16 w-auto object-contain"
              style={{ maxWidth: '180px' }}
            />
          </div>
          <div className="flex flex-col gap-1 mb-6">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="px-4 py-3 rounded-xl text-base font-medium text-white/70 hover:text-white hover:bg-white/5 transition-all cursor-pointer"
              >
                {link.label}
              </Link>
            ))}
          </div>
          <div className="flex flex-col gap-3">
            <a
              href="tel:+48600601093"
              className="w-full py-3.5 rounded-xl text-center font-semibold text-white/70 border border-white/10 flex items-center justify-center gap-2 cursor-pointer"
            >
              <i className="ri-phone-line text-[#00ff88]" />
              600 601 093
            </a>
            <Link
              to="/kontakt"
              className="w-full py-4 rounded-xl text-center font-bold text-black cursor-pointer"
              style={{ background: 'linear-gradient(135deg, #00d4ff, #00b8e6)' }}
            >
              Bezpłatna konsultacja
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
